import { render, staticRenderFns } from "./CouncillorDataTable.vue?vue&type=template&id=45eea59e"
import script from "./CouncillorDataTable.vue?vue&type=script&lang=js"
export * from "./CouncillorDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports